export const useGetPerformance = (performance: string | number | null) => {
  if (performance === "" || performance === null || performance === undefined) {
    return "n/a";
  } else {
    return performance;
  }
};
